import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import BigCalendar from './components/BigCalendar';
import EventLabels from './components/EventLabels';
import Spinner from 'react-bootstrap/Spinner';

const Calendar = ({ rtl }) => {

  const user = JSON.parse(sessionStorage.getItem('usuario'));
  const [dataEvents, setDataEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const fecha = new Date();

  const getCalendarData = async () => {

      setLoading(true);

      await fetch(process.env.REACT_APP_PUBLIC_URL + 'calendario/listar?id_usuario=' + user.id_usuario + '&month=' + (fecha.getMonth() + 1) + '&year=' + fecha.getFullYear(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(data => {     
          filterData(data);

        })
        .catch((error) => {
          console.error('Error:', error);
        });
    
  };
  const filterData = (data) => {
    let newData = [];

    for (let i = 0; i < data.length; i++) {
      newData[i] = {
        id: data[i].id_calendario,
        title: data[i].titulo,
        start: new Date(data[i].fecha_inicio),
        end: new Date(data[i].fecha_final),
        priority: data[i].prioridad === 1 ? 'non' : data[i].prioridad === 2 ? 'family' : 'high',
      }
    }

    setDataEvents(newData);
    setLoading(false);

  }

  useEffect(() => {
    getCalendarData();
  }, []);

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Calendario</h3>
          <h3 className="page-subhead subhead">Utilice estos elementos si desea mostrar sugerencias o información adicional.</h3>
        </Col>
      </Row>
      <Row>
        {loading ?
          <Spinner animation="border" variant="success" />
          :
          <BigCalendar dir={rtl.direction} events={dataEvents}  />
        }
        <EventLabels reload={getCalendarData} />
      </Row>
    </Container>
  );
}

Calendar.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(Calendar);
